import NBType, { InferType } from '@netbase/nb-type'

const AuthorSchema = NBType.object().shape('AuthorSchema', {
  /* @prop */
  authorName: NBType.string().nullable(),
  /* @prop */
  domain: NBType.string().nullable(),
  /* @prop */
  name: NBType.string().nullable(),
  /* @prop */
  authorID: NBType.string().nullable()
  /* END */
})
export default AuthorSchema
export type Author = InferType<typeof AuthorSchema>
// RESERVE BELOW
